// Lead Master Azim
export const FETCH_ALL_LEADS_START = "FETCH_ALL_LEADS_START";
export const FETCH_ALL_LEADS_SUCCESS = "FETCH_ALL_LEADS_SUCCESS";
export const FETCH_ALL_LEADS_FAIL = "FETCH_ALL_LEADS_FAIL";

export const CURRENT_UPDATING_TAB = "CURRENT_UPDATING_TAB";

export const FETCH_TEAM_MEMBER_START = "FETCH_TEAM_MEMBER_START";
export const FETCH_TEAM_MEMBER_SUCCESS = "FETCH_TEAM_MEMBER_SUCCESS";
export const FETCH_TEAM_MEMBER_FAIL = "FETCH_TEAM_MEMBER_FAIL";

export const FETCH_DESIGNATION_START = "FETCH_DESIGNATION_START";
export const FETCH_DESIGNATION_SUCCESS = "FETCH_DESIGNATION_SUCCESS";
export const FETCH_DESIGNATION_FAIL = "FETCH_DESIGNATION_FAIL";
export const UPDATE_TAB_POSSITION = "UPDATE_TAB_POSSITION";
export const UPDATE_ALLCATION_TAB_POSSITION = "UPDATE_ALLCATION_TAB_POSSITION";
export const UPDATE_ALLCATED_CHECKED_LEADS = "UPDATE_ALLCATED_CHECKED_LEADS";
export const CURRENT_UPDATING_ID = "CURRENT_UPDATING_ID";
export const UPDATE_PROPOSAL_TEAM = "UPDATE_PROPOSAL_TEAM";
export const SHOW_PROPOSAL_TABLE = "SHOW_PROPOSAL_TABLE";
export const SELECTED_FILTER_BY = "SELECTED_FILTER_BY";

export const FETCH_ALL_TEAM_COUNT = "FETCH_ALL_TEAM_COUNT";
export const FETCH_ALL_TEAM_COUNTT = "FETCH_ALL_TEAM_COUNTT";

// export const FETCH_TODAY_LEADS_START =  'FETCH_TODAY_LEADS_START'
// export const FETCH_TODAY_LEADS_SUCCESS =  'FETCH_TODAY_LEADS_SUCCESS'
// export const FETCH_TODAY_LEADS_FAIL =  'FETCH_TODAY_LEADS_FAIL'

// export const FETCH_OPEN_LEADS_START =  'FETCH_OPEN_LEADS_START'
// export const FETCH_OPEN_LEADS_SUCCESS =  'FETCH_OPEN_LEADS_SUCCESS'
// export const FETCH_OPEN_LEADS_FAIL =  'FETCH_OPEN_LEADS_FAIL'

// export const FETCH_CONVERTED_LEADS_START =  'FETCH_CONVERTED_LEADS_START'
// export const FETCH_CONVERTED_LEADS_SUCCESS =  'FETCH_CONVERTED_LEADS_SUCCESS'
// export const FETCH_CONVERTED_LEADS_FAIL =  'FETCH_CONVERTED_LEADS_FAIL'

// export const FETCH_FAILED_LEADS_START =  'FETCH_FAILED_LEADS_START'
// export const FETCH_FAILED_LEADS_SUCCESS =  'FETCH_FAILED_LEADS_SUCCESS'
// export const FETCH_FAILED_LEADS_FAIL =  'FETCH_FAILED_LEADS_FAIL'

export const FETCH_LEAD_CATEGORY_START = "FETCH_LEAD_CATEGORY_START";
export const FETCH_LEAD_CATEGORY_SUCCESS = "FETCH_LEAD_CATEGORY_SUCCESS";
export const FETCH_LEAD_CATEGORY_FAIL = "FETCH_LEAD_CATEGORY_FAIL";

export const FETCH_LEAD_DETAILS_START = "FETCH_LEAD_DETAILS_START";
export const FETCH_LEAD_DETAILS_SUCCESS = "FETCH_LEAD_DETAILS_SUCCESS";
export const FETCH_LEAD_DETAILS_FAIL = "FETCH_LEAD_DETAILS_FAIL";

export const FETCH_HISTORY_START = "FETCH_HISTORY_START";
export const FETCH_HISTORY_SUCCESS = "FETCH_HISTORY_SUCCESS";
export const FETCH_HISTORY_FAIL = "FETCH_HISTORY_FAIL";

export const CREATE_LEAD_START = "CREATE_LEAD_START";
export const CREATE_LEAD_SUCCESS = "CREATE_LEAD_SUCCESS";
export const CREATE_LEAD_FAIL = "CREATE_LEAD_FAIL";

export const EDIT_LEAD_START = "EDIT_LEAD_START";
export const EDIT_LEAD_SUCCESS = "EDIT_LEAD_SUCCESS";
export const EDIT_LEAD_FAIL = "EDIT_LEAD_FAIL";

export const STORE_FORM_SUCCESS = "STORE_FORM_SUCCESS";

export const FETCH_PRODUCT_START = "FETCH_PRODUCT_START";
export const FETCH_PRODUCT_SUCCESS = "FETCH_PRODUCT_SUCCESS";
export const FETCH_PRODUCT_FAIL = "FETCH_PRODUCT_FAIL";

export const FETCH_PLAN_NAME_START = "FETCH_PLAN_NAME_START";
export const FETCH_PLAN_NAME_SUCCESS = "FETCH_PLAN_NAME_SUCCESS";
export const FETCH_PLAN_NAME_FAIL = "FETCH_PLAN_NAME_FAIL";
// Addresses
export const FETCH_STATES_START = "FETCH_STATES_START";
export const FETCH_STATES_SUCCESS = "FETCH_STATES_SUCCESS";
export const FETCH_STATES_FAIL = "FETCH_STATES_FAIL";

export const FETCH_CITIES_START = "FETCH_CITIES_START";
export const FETCH_CITIES_SUCCESS = "FETCH_CITIES_SUCCESS";
export const FETCH_CITIES_FAIL = "FETCH_CITIES_FAIL";

export const FETCH_COUNTRY_START = "FETCH_COUNTRY_START";
export const FETCH_COUNTRY_SUCCESS = "FETCH_COUNTRY_SUCCESS";
export const FETCH_COUNTRY_FAIL = "FETCH_COUNTRY_FAIL";

// Login Shiva
export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const MULTI_CHANNEL = "MULTI_CHANNEL";

export const AUTH_LOGOUT_START = "AUTH_LOGOUT_START";
export const AUTH_LOGOUT_SUCCESS = "AUTH_LOGOUT_SUCCESS";
export const AUTH_LOGOUT_FAIL = "AUTH_LOGOUT_FAIL";

export const FETCH_USER_DETAILS_START = "FETCH_USER_DETAILS_START";
export const FETCH_USER_DETAILS_SUCCESS = "FETCH_USER_DETAILS_SUCCESS";
export const FETCH_USER_DETAILS_FAIL = "FETCH_USER_DETAILS_FAIL";

export const FETCH_HIERARCHY_START = "FETCH_HIERARCHY_START";
export const FETCH_HIERARCHY_SUCCESS = "FETCH_HIERARCHY_SUCCESS";
export const FETCH_HIERARCHY_FAIL = "FETCH_HIERARCHY_FAIL";

export const FORGOT_PASSWORD_START = "FORGOT_PASSWORD_START";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAIL = "FORGOT_PASSWORD_FAIL";

export const HOME_START = "HOME_START";
export const HOME_SUCCESS = "HOME_SUCCESS";
export const HOME_FAIL = "HOME_FAIL";
export const USER_TREE = "USER_TREE";
export const BUSINESS_CARD = "BUSINESS_CARD";

export const ACTIVITIES_START = "ACTIVITIES_START";
export const ACTIVITIES_SUCCESS = "ACTIVITIES_SUCCESS";
export const ACTIVITIES_FAIL = "ACTIVITIES_FAIL";

export const TODO_START = "TODO_START";
export const TODO_SUCCESS = "TODO_SUCCESS";

//KPI DASHBOARD
export const KPI_DASHBOARD_START = "KPI_DASHBOARD_START";
export const KPI_DASHBOARD_SUCCESS = "KPI_DASHBOARD_SUCCESS";
export const KPI_DASHBOARD_FAIL = "KPI_DASHBOARD_FAIL";

//all renewals
export const FETCH_ALL_RENEWALS_START = "FETCH_ALL_RENEWALS_START";
export const FETCH_ALL_RENEWALS_SUCCESS = "FETCH_ALL_RENEWALS_SUCCESS";
export const FETCH_ALL_RENEWALS_FAIL = "FETCH_ALL_RENEWALS_FAIL";
//paid renewals
export const FETCH_PAID_RENEWALS_START = "FETCH_PAID_RENEWALS_START";
export const FETCH_PAID_RENEWALS_SUCCESS = "FETCH_PAID_RENEWALS_SUCCESS";
export const FETCH_PAID_RENEWALS_FAIL = "FETCH_PAID_RENEWALS_FAIL";
//unpaid renewals
export const FETCH_UNPAID_RENEWALS_START = "FETCH_UNPAID_RENEWALS_START";
export const FETCH_UNPAID_RENEWALS_SUCCESS = "FETCH_UNPAID_RENEWALS_SUCCESS";
export const FETCH_UNPAID_RENEWALS_FAIL = "FETCH_UNPAID_RENEWALS_FAIL";
//lapsed renewals
export const FETCH_LAPSED_RENEWALS_START = "FETCH_LAPSED_RENEWALS_START";
export const FETCH_LAPSED_RENEWALS_SUCCESS = "FETCH_LAPSED_RENEWALS_SUCCESS";
export const FETCH_LAPSED_RENEWALS_FAIL = "FETCH_LAPSED_RENEWALS_FAIL";

// renewal details
export const FETCH_DETAILS_RENEWALS_START = "FETCH_DETAILS_RENEWALS_START";
export const FETCH_DETAILS_RENEWALS_SUCCESS = "FETCH_DETAILS_RENEWALS_SUCCESS";
export const FETCH_DETAILS_RENEWALS_FAIL = "FETCH_DETAILS_RENEWALS_FAIL";

// Agent Mirco Site
export const FETCH_AGENT_DETAILS_START = "FETCH_AGENT_DETAILS_START";
export const FETCH_AGENT_DETAILS_SUCCESS = "FETCH_AGENT_DETAILS_SUCCESS";
export const FETCH_AGENT_DETAILS_FAIL = "FETCH_AGENT_DETAILS_FAIL";

// Agent Micro site blog
export const FETCH_BLOGS_START = "FETCH_BLOGS_START";
export const FETCH_BLOGS_SUCCESS = "FETCH_BLOGS_SUCCESS";
export const FETCH_BLOGS_FAIL = "FETCH_BLOGS_FAIL";

//fetch company details
export const FETCH_COMPANY_START = "FETCH_COMPANY_START";
export const FETCH_COMPANY_SUCCESS = "FETCH_COMPANY_SUCCESS";
export const FETCH_COMPANY_FAIL = "FETCH_COMPANY_FAIL";

// Advisor List
export const FETCH_ADVISOR_LIST_START = "FETCH_ADVISOR_LIST_START";
export const FETCH_ADVISOR_LIST_SUCCESS = "FETCH_ADVISOR_LIST_SUCCESS";
export const FETCH_ADVISOR_LIST_FAIL = "FETCH_ADVISOR_LIST_FAIL";
export const FETCH_NEED_ANALYSIS_DATA = "FETCH_NEED_ANALYSIS_DATA";
export const ADD_RECOMMENDED_PRODUCTS = "ADD_RECOMMENDED_PRODUCTS";
export const DELETE_OLD_RECOMMENDED_PRODUCTS = "DELETE_OLD_RECOMMENDED_PRODUCTS";

//Proposal List
export const FETCH_ALL_PROPOSAL_DETAILS_SUCCESS = "FETCH_ALL_PROPOSAL_DETAILS_SUCCESS";
export const FETCH_ALL_PROPOSAL_AGENT_DETAILS = "FETCH_ALL_PROPOSAL_AGENT_DETAILS";
export const FETCH_ALL_PROPOSAL_AGENT_DETAILS_START = "FETCH_ALL_PROPOSAL_AGENT_DETAILS_START";
export const FETCH_ALL_PROPOSAL_AGENT_DETAILS_FAIL = "FETCH_ALL_PROPOSAL_AGENT_DETAILS_FAIL";

//proposal form filling
export const PROPOSAL_ID = "PROPOSAL_ID";
export const CREATE_PROPOSAL_FORM_START = "CREATE_PROPOSAL_FORM_START";
export const CREATE_PROPOSAL_FORM_SUCCESS = "CREATE_PROPOSAL_FORM_SUCCESS";
export const CREATE_PROPOSAL_FORM_FAIL = "CREATE_PROPOSAL_FORM_FAIL";

//PROPOSAL INDIVIDAUAL DATA
export const ADD_PROPOSAL_BI_FORM_DATA = "ADD_PROPOSAL_BI_FORM_DATA";
export const MANDATORY_DOCUMENT_UPLOAD = "MANDATORY_DOCUMENT_UPLOAD";
export const PROPOSAL_FORM_FILLING_LIFEINSURANCE = "PROPOSAL_FORM_FILLING_LIFEINSURANCE";
export const PROPOSAL_FORM_FILLING_PERSONALDETAILS = "PROPOSAL_FORM_FILLING_PERSONALDETAILS";
export const DYNAMIC_DOCUMENT_UPLOAD = "DYNAMIC_DOCUMENT_UPLOAD";
export const PAYMENT = "PAYMENT";
export const ESIR_AUTHENTICATION = "ESIR_AUTHENTICATION";
export const STORE_PROPOSAL_FORM_SUCCESS = "STORE_PROPOSAL_FORM_SUCCESS";
export const EDIT_PROPOSAL_FORM_DATA = "EDIT_PROPOSAL_FORM_DATA";
export const DELETE_PROPOSAL_FORM_DATA = "DELETE_PROPOSAL_FORM_DATA";

//BI Object Store
export const FETCH_BENEFIT_ILLUSTRATION = "FETCH_BENEFIT_ILLUSTRATION";
export const FETCH_BENEFIT_ILLUSTRATION_START = "FETCH_BENEFIT_ILLUSTRATION_START";
export const FETCH_BENEFIT_ILLUSTRATION_SUCCESS = "FETCH_BENEFIT_ILLUSTRATION_SUCCESS";
export const FETCH_BENEFIT_ILLUSTRATION_FAIL = "FETCH_BENEFIT_ILLUSTRATION_FAIL";

//Einsurance PROPOSAL FORM OBJECT
export const FETCH_EINSURANCE = "FETCH_EINSURANCE";
export const FETCH_EINSURANCE_START = "FETCH_EINSURANCE_START";
export const FETCH_EINSURANCE_SUCCESS = "FETCH_EINSURANCE_SUCCESS";
export const FETCH_EINSURANCE_FAIL = "FETCH_EINSURANCE_FAIL";
export const CLEAR_STORE_EINSURANCE = "CLEAR_STORE_EINSURANCE";

//Clear lead
export const RESET_LEAD = "RESET_LEAD";

//Details of the plan applied for
export const FETCH_DETAILS_OF_PLAN = "FETCH_DETAILS_OF_PLAN";
export const FETCH_DETAILS_OF_PLAN_START = "FETCH_DETAILS_OF_PLAN_START";
export const FETCH_DETAILS_OF_PLAN_SUCCESS = "FETCH_DETAILS_OF_PLAN_SUCCESS";
export const FETCH_DETAILS_OF_PLAN_FAIL = "FETCH_DETAILS_OF_PLAN_FAIL";

//About Customer
export const FETCH_ABOUT_CUSTOMER = "FETCH_ABOUT_CUSTOMER";
export const FETCH_ABOUT_CUSTOMER_START = "FETCH_DETAILS_OF_PLAN_START";
export const FETCH_ABOUT_CUSTOMER_SUCESS = "FETCH_ABOUT_CUSTOMER_SUCESS";
export const FETCH_ABOUT_CUSTOMER_FAIL = "FETCH_DETAILS_OF_PLAN_FAIL";

//Financial Details
export const FETCH_FINANCIAL_DETAILS = "FETCH_FINANCIAL_DETAILS";
export const FETCH_FINANCIAL_DETAILS_START = "FETCH_DETAILS_OF_PLAN_START";
export const FETCH_FINANCIAL_DETAILS_SUCESS = "FETCH_FINANCIAL_DETAILS_SUCESS";
export const FETCH_FINANCIAL_DETAILS_FAIL = "FETCH_DETAILS_OF_PLAN_FAIL";

//Health Details/DGH section
export const FETCH_HEALTH_DETAILS = "FETCH_HEALTH_DETAILS";
export const FETCH_HEALTH_DETAILS_START = "FETCH_DETAILS_OF_PLAN_START";
export const FETCH_HEALTH_DETAILS_SUCESS = "FETCH_HEALTH_DETAILS_SUCESS";
export const FETCH_HEALTH_DETAILS_FAIL = "FETCH_DETAILS_OF_PLAN_FAIL";

//Previous Policy Details
export const FETCH_PREVIOUS_POLICY_DETAILS = "FETCH_PREVIOUS_POLICY_DETAILS";
export const FETCH_PREVIOUS_POLICY_DETAILS_START = "FETCH_DETAILS_OF_PLAN_START";
export const FETCH_PREVIOUS_POLICY_DETAILS_SUCESS = "FETCH_PREVIOUS_POLICY_DETAILS_SUCESS";
export const FETCH_PREVIOUS_POLICY_DETAILS_FAIL = "FETCH_DETAILS_OF_PLAN_FAIL";

//Nomination Details
export const FETCH_NOMINATION_DETAILS = "FETCH_NOMINATION_DETAILS";
export const FETCH_NOMINATION_DETAILS_START = "FETCH_DETAILS_OF_PLAN_START";
export const FETCH_NOMINATION_DETAILS_SUCESS = "FETCH_NOMINATION_DETAILS_SUCESS";
export const FETCH_NOMINATION_DETAILS_FAIL = "FETCH_DETAILS_OF_PLAN_FAIL";

//Declaration
export const FETCH_DECLARATION = "FETCH_DECLARATION";
export const FETCH_DECLARATION_START = "FETCH_DECLARATION_START";
export const FETCH_DECLARATION_SUCESS = "FETCH_DECLARATION_SUCESS";
export const FETCH_DECLARATION_FAIL = "FETCH_DECLARATION_FAIL";

//PROPOSAL DETAILS
export const FETCH_PROPOSAL_DETAILS = "FETCH_PROPOSAL_DETAILS";
export const FETCH_PROPOSAL_DETAILS_START = "FETCH_DETAILS_OF_PLAN_START";
export const FETCH_PROPOSAL_DETAILS_SUCESS = "FETCH_PROPOSAL_DETAILS_SUCESS";
export const FETCH_PROPOSAL_DETAILS_FAIL = "FETCH_DETAILS_OF_PLAN_FAIL";

//Payment
export const FETCH_PAYMENT = "FETCH_PAYMENT";
export const FETCH_PAYMENT_START = "FETCH_DETAILS_OF_PLAN_START";
export const FETCH_PAYMENT_SUCESS = "FETCH_PAYMENT_SUCESS";
export const FETCH_PAYMENT_FAIL = "FETCH_DETAILS_OF_PLAN_FAIL";

//ENACH
export const FETCH_ENACH = "FETCH_ENACH";
export const FETCH_ENACH_START = "FETCH_DETAILS_OF_PLAN_START";
export const FETCH_ENACH_SUCESS = "FETCH_ENACH_SUCESS";
export const FETCH_ENACH_FAIL = "FETCH_DETAILS_OF_PLAN_FAIL";

//ESIR Propsal Form
export const ADD_ESIR_PROPOSAL_FORM = "ADD_ESIR_PROPOSAL_FORM";

//Ekyc details status lead
export const FETCH_LI_EKYC_DETAILS = "FETCH_LI_EKYC_DETAILS";
export const FETCH_PROPOSER_EKYC_DETAILS = "FETCH_PROPOSER_EKYC_DETAILS";

export const FETCH_ALL_PRODUCTS = "FETCH_ALL_PRODUCTS";

//self and refrence

export const FETCH_LEAD_TYPE = "FETCH_LEAD_TYPE";

//Gap Calculator
export const FETCH_GAP_CALC = "FETCH_GAP_CALC";
// export const FETCH_ALL_GAP_DATA = "FETCH_ALL_GAP_DATA";
// export const FETCH_FORMDATA_PAGE1 = "FETCH_FORMDATA_PAGE1";
// export const FETCH_FORMDATA_PAGE2 = "FETCH_FORMDATA_PAGE2";
export const FETCH_GAP_CALC_START = "FETCH_GAP_CALC_START";
export const FETCH_GAP_CALC_SUCCESS = "FETCH_GAP_CALC_SUCCESS";
export const FETCH_GAP_CALC_FAIL = "FETCH_GAP_CALC_FAIL";
export const STORE_ALL_CALC_FORM_DATA = "STORE_ALL_CALC_FORM_DATA";
export const RESET_GAP_DATA = "RESET_GAP_DATA";
export const GET_GAP_DATA_START = "GET_GAP_DATA_START";
export const GET_GAP_DATA_SUCCESS = "GET_GAP_DATA_SUCCESS";
export const GET_GAP_DATA_FAIL = "GET_GAP_DATA_FAIL";
//for subsource
export const GET_SUB_SOURCE = "GET_SUB_SOURCE";

//multi li selected key
export const FETCH_MULTI_SELECTED_ID = "FETCH_MULTI_SELECTED_ID";

// ENACH RULE
export const FETCHENACHRULE = "FETCHENACHRULE";

// IIb count

export const IIBCOUNT = "IIBCOUNT"
export const PROPOSAL_TEAM_DATA = "PROPOSAL_TEAM_DATA"

// number of proposal
export const EDIT_PROPOSAL_FORM_NUMBER = "EDIT_PROPOSAL_FORM_NUMBER";

export const CHECK_MEDICAL_APPLICABILITY_START = "CHECK_MEDICAL_APPLICABILITY_START";
export const CHECK_MEDICAL_APPLICABILITY_SUCCESS = "CHECK_MEDICAL_APPLICABILITY_SUCCESS";
export const CHECK_MEDICAL_APPLICABILITY_FAIL = "CHECK_MEDICAL_APPLICABILITY_FAIL";
export const SCHEDULE_MEDICAL_START = "SCHEDULE_MEDICAL_START";
export const SCHEDULE_MEDICAL_SUCCESS = "SCHEDULE_MEDICAL_SUCCESS";
export const SCHEDULE_MEDICAL_FAIL = "SCHEDULE_MEDICAL_FAIL";

// Ekyc facematch
export const EKYC_FACEMATCH_START = "EKYC_FACEMATCH_START";
export const EKYC_FACEMATCH_SUCCESS = "EKYC_FACEMATCH_SUCCESS";
export const EKYC_FACEMATCH_FAIL = "EKYC_FACEMATCH_FAIL";

// Medical Test Master
export const FETCH_MEDICAL_TEST_MASTER_START = "FETCH_MEDICAL_TEST_MASTER_START";
export const FETCH_MEDICAL_TEST_MASTER_SUCCESS = "FETCH_MEDICAL_TEST_MASTER_SUCCESS";
export const FETCH_MEDICAL_TEST_MASTER_FAIL = "FETCH_MEDICAL_TEST_MASTER_FAIL";

export const TRIGGER_OPPORTUNITY_API_START = "TRIGGER_OPPORTUNITY_API_START";
export const TRIGGER_OPPORTUNITY_API_SUCCESS = "TRIGGER_OPPORTUNITY_API_SUCCESS";
export const TRIGGER_OPPORTUNITY_API_FAIL = "TRIGGER_OPPORTUNITY_API_FAIL";
